export enum DIRECTION {
    ONEWAY = 'ONEWAY',
    ROUNDTRIP = 'ROUNDTRIP',
}

export enum ORDER_STATUS {
    AWAITING_PAYMENT = 'AWAITING_PAYMENT',
    RESERVED = 'RESERVED',
    CANCELED = 'CANCELED',
    REFUNDED = 'REFUNDED',
    PAYMENT_EXPIRED = 'PAYMENT_EXPIRED',
    PAYMENT_ABANDONED = 'PAYMENT_ABANDONED',
    PAYMENT_REFUSED = 'PAYMENT_REFUSED',
    PAYMENT_ERROR = 'PAYMENT_ERROR',
    PAYMENT_ACCEPTED = 'PAYMENT_ACCEPTED',
    // PRECOMMANDES (PROS)

    /**
     * Option de réservation enregistrée
     */
     PREORDER_RESERVED = 'PREORDER_RESERVED',
     /**
      * Option de réservation confirmée (si créée ou validée depuis BO)\
      * *Ceci permet de vérifier la validité, si PREORDER_CONFIRMED un email est envoyé au Pro pour signature*
      */
     PREORDER_CONFIRMED = 'PREORDER_CONFIRMED',
     /**
      * Option de réservation validée par le pro (signature numérique)\
      * *Le Pro peut alors télécharger un **Bon de Réservation** afin de procéder à l'embarquement*
      */
     PREORDER_AWAITING_PAYMENT = 'PREORDER_AWAITING_PAYMENT',
     /**
      * Paiement physique sur pré-commande de professionnel
      */
     PREORDER_PAID = 'PREORDER_PAID',
     /**
      * Pré commande annulée depuis le BO
      */
     PREORDER_CANCELED = 'PREORDER_CANCELED',
     /**
      * Pré commande annulée par le client
      */
     PREORDER_CANCELEDBYUSER = 'PREORDER_CANCELEDBYUSER',
     /**
      * Commande annulée par le client
      */
     ORDER_CANCELEDBYUSER = "ORDER_CANCELEDBYUSER",
     /**
      * Paiement physique sur commande de particulier
      */
     PAID = 'PAID',
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/orders/orders.constant.ts